import React from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';

import PromoBadge from '@/assets/icons/promo-badge';
import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { getLayoutAnimationsTransition } from '@/utils/animations/layout-animations-utils';

import { PickbarMessageMode } from './FantasyPickbar';

export const PickbarMessage = ({ mode }: { mode: PickbarMessageMode }) => {
    const layoutTransition = getLayoutAnimationsTransition();

    const renderPicksFromSameTeam = () => {
        return (
            <Text textAlign={'center'} color={'neutral300'} variant={'bodySmaller'} lineHeight={16}>
                2+ teams are required
            </Text>
        );
    };

    const renderMysteryMultiplierAvailable = () => {
        return (
            <Row alignItems={'center'} justifyContent={'center'}>
                <PromoBadge color={ds.colorValue.icon.brand} />
                <Text variant={'bodySmaller'} marginLeft={'s4'} color={ds.colorToken.text.brand} lineHeight={16}>
                    Mystery Multiplier available
                </Text>
            </Row>
        );
    };

    return (
        <Animated.View layout={layoutTransition} style={styles.messageBoxVisible}>
            {mode === 'sameTeam' ? renderPicksFromSameTeam() : null}
            {mode === 'mystery' ? renderMysteryMultiplierAvailable() : null}
        </Animated.View>
    );
};

const styles = StyleSheet.create({
    messageBoxVisible: {
        paddingBottom: 8,
        opacity: 1,
        height: 24,
    },
});
